/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreOverview } from './StoreOverview';
import {
    StoreOverviewFromJSON,
    StoreOverviewFromJSONTyped,
    StoreOverviewToJSON,
    StoreOverviewToJSONTyped,
} from './StoreOverview';

/**
 * 
 * @export
 * @interface StoreProfileDraft
 */
export interface StoreProfileDraft {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileDraft
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileDraft
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileDraft
     */
    updatedAt?: Date;
    /**
     * 
     * @type {StoreOverview}
     * @memberof StoreProfileDraft
     */
    store: StoreOverview;
}

/**
 * Check if a given object implements the StoreProfileDraft interface.
 */
export function instanceOfStoreProfileDraft(value: object): value is StoreProfileDraft {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function StoreProfileDraftFromJSON(json: any): StoreProfileDraft {
    return StoreProfileDraftFromJSONTyped(json, false);
}

export function StoreProfileDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'store': StoreOverviewFromJSON(json['store']),
    };
}

export function StoreProfileDraftToJSON(json: any): StoreProfileDraft {
    return StoreProfileDraftToJSONTyped(json, false);
}

export function StoreProfileDraftToJSONTyped(value?: StoreProfileDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'store': StoreOverviewToJSON(value['store']),
    };
}

